var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpainFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.673 473.673",
    style: {
      enableBackground: "new 0 0 473.673 473.673"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C42126"
    },
    d: "M236.836,473.673c75.779,0,143.185-35.619,186.534-90.991H298.632 C282.529,436.36,273.542,473.673,236.836,473.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C42126"
    },
    d: "M222.79,473.265c-0.045,0-0.086-0.007-0.131-0.007C222.704,473.258,222.749,473.265,222.79,473.265z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C42126"
    },
    d: "M298.632,90.991h124.741C380.02,35.627,312.613,0,236.836,0 C273.542,0,282.529,37.313,298.632,90.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C42126"
    },
    d: "M222.659,0.423c0.045,0,0.086-0.007,0.131-0.007C222.749,0.415,222.704,0.415,222.659,0.423z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC40C"
    },
    d: "M423.376,90.991H298.632c25.175,83.909,25.175,207.793,0,291.69h124.733 c31.487-40.208,50.308-90.808,50.308-145.843C473.677,181.807,454.855,131.203,423.376,90.991z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C42126"
    },
    d: "M236.836,473.673c-4.712,0-9.394-0.138-14.046-0.408 C227.508,473.527,232.199,473.673,236.836,473.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C42126"
    },
    d: "M222.79,0.415C227.441,0.138,232.124,0,236.836,0C232.199,0,227.508,0.153,222.79,0.415z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32030"
    },
    d: "M316.053,382.682H50.309c40.623,51.894,102.386,86.44,172.349,90.576 c0.045,0,0.086,0.007,0.131,0.007c4.652,0.269,9.334,0.408,14.046,0.408C273.542,473.673,299.947,436.36,316.053,382.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32030"
    },
    d: "M50.309,90.991h265.745C299.947,37.313,273.542,0,236.836,0c-4.712,0-9.394,0.138-14.046,0.415 c-0.045,0-0.086,0.007-0.131,0.007C152.695,4.555,90.932,39.105,50.309,90.991z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD034"
    },
    d: "M0.001,236.838c0,55.035,18.821,105.635,50.308,145.843h265.745 c25.175-83.901,25.175-207.786,0-291.69H50.309C18.822,131.203,0.001,181.807,0.001,236.838z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpainFlag);
export default __webpack_public_path__ + "static/media/spain-flag.a0d612b5687035bbefe1bfc28ba92107.svg";
export { ForwardRef as ReactComponent };